import { MouseEvent } from "react"
import TruncatedText from "../../Page/TruncatedText"

export default function TextCell({
    value,
    alignment,
    action,
    headerIndex,
    hasPadding,
}: {
    value: string,
    alignment: 'left' | 'center',
    action?: (e: MouseEvent<HTMLButtonElement>) => void,
    headerIndex: number,
    hasPadding: boolean,
}) {
    return (
            <div className={`flex ${alignment === 'left' ? 'justify-start' : 'justify-center'} items-center gap-2 ${hasPadding && 'py-4 px-6'}`}>
                <TruncatedText text={value} alignment={alignment}>
                {action ? (
                    <button className={`${headerIndex === 0 ? 'relative z-20' : ''} ${alignment === 'left' ? 'text-left' : 'text-center'} text-[14px] text-nowrap font-medium text-highlight hover:text-primary transition-all max-w-[300px] truncate`} onClick={action}>{value}</button>
                ) : (
                    <p className="text-[14px] text-nowrap font-medium text-default max-w-[300px] truncate">{value}</p>
                )}
                </TruncatedText>
            </div>
    )
}